import React from 'react';
import type { CollectionListItem } from 'src/web/collections/types';

import Routes from 'routing/Routes';
import { Link } from 'components/common/router';

type Props = Pick<CollectionListItem, 'id' | 'title'>;

const TitleCell = ({ id, title }: Props) => (
  <Link to={Routes.pluginRoute('COLLECTIONS_COLLECTIONID')(id)}>{title}</Link>
);
export default TitleCell;
